import "./App.css"

import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"

import { FormProvider } from "react-hook-form"
import {

  RouterProvider,
  createBrowserRouter,
  redirect
} from "react-router-dom"

import EnterCode from "./Pages/EnterCode"
import { ToastProvider } from "./Providers/ToastProvider"
import { theme } from "./api/utils"
import WaitForUser from "./Pages/WaitForUser"
import DisplayData from "./Pages/DisplayData"

// Codes shared as a link (connect.getmydetails.com/123456) may pick up
// separators along the way, so tidy them before prefilling the form.
const normaliseCode = (value) => {
  const cleaned = String(value ?? "")
    .trim()
    .replace(/[\s\-_]/g, "")
  return /^\d{4,10}$/.test(cleaned) ? cleaned : ""
}

//The world starts here
function App() {
  const router = createBrowserRouter([
    {
      path: "/data/:id",
      loader: ({ params }) => {
        return { id: params.id }
      },
      element: <DisplayData />
    },
    {
      path: "/connection/:id",
      loader: ({ params }) => {
        return { id: params.id }
      },
      element: <WaitForUser />
    },
    {
      path: "/",
      loader: ({ request }) => {
        const { searchParams } = new URL(request.url)
        return {
          inputcode: normaliseCode(
            searchParams.get("code") ?? searchParams.get("c")
          )
        }
      },
      element: <EnterCode />
    },
    {
      path: "/:code",
      loader: ({ params }) => {
        const inputcode = normaliseCode(params.code)
        return inputcode ? { inputcode } : redirect("/")
      },
      element: <EnterCode />
    },
    {
      path: "*",
      loader: () => redirect("/")
    }
  ])

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <FormProvider>
          <CssBaseline />
          <div className="app">
            <RouterProvider router={router} />
            {/* <Router>
              <Routes>
                <Route path="/" element={<EnterCode />} />
              </Routes>
            </Router> */}
          </div>
        </FormProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}
export default App
